import { HttpHeaders } from '@angular/common/http';

export interface ISlackAPIConfig {
  logWebhookUrl: string;
  httpHeaders: HttpHeaders;
  pretext: string;
  channel?: string;
}
